import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { WMSSelect } from "../../widgets/selectbox";
import { WMSInput } from "../../widgets/input";
import { invokeGetService, invokePostService } from "../../service";
import { apiUrl } from "../../base/utils";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { toastError, toastSuccess } from "../../widgets/toaster";
import WHSLoader from "../../widgets/loader";
import { connect } from "react-redux";
import HOCAutoLogout from "../autologout";

const generalFields = [
  {
    label: "Role",
    placeHolder: "Select role",
    fieldName: "role",
    value: "",
    fieldType: "dropdown",
    dataType: "number",
    required: true,
    disabled: false,
    pattern: "",
    maxLength: "",
  },
  {
    label: "Assign Journal",
    placeHolder: "Select journal",
    fieldName: "assignedjournal",
    value: "",
    fieldType: "dropdown",
    dataType: "number",
    required: true,
    disabled: false,
    pattern: "",
    maxLength: "",
  },
  {
    label: "First Name",
    placeHolder: "Enter first name",
    fieldName: "firstname",
    value: "",
    fieldType: "text",
    dataType: "number",
    required: true,
    disabled: false,
    pattern: "/^[a-zA-Z]+$/",
    maxLength: "50",
  },
  // { label: 'Middle Name', placeHolder: 'Enter middle name', fieldName: 'middlename', value: '', fieldType: 'text', dataType: 'number', required: false, disabled: false, pattern: '/^[a-zA-Z]+$/', maxLength: '50' },
  {
    label: "Last Name",
    placeHolder: "Enter last name",
    fieldName: "lastname",
    value: "",
    fieldType: "text",
    dataType: "number",
    required: true,
    disabled: false,
    pattern: "/^[a-zA-Z]+$/",
    maxLength: "50",
  },
  {
    label: "Email ID",
    placeHolder: "Enter email",
    fieldName: "email",
    value: "",
    fieldType: "text",
    dataType: "number",
    required: true,
    disabled: false,
    pattern: "/^[w-]+(.[w-]+)*@([w-]+.)+[a-zA-Z]{2,7}$/",
    maxLength: "50",
  },
  // { label: 'Password', placeHolder: 'Enter password', fieldName: 'password', value: '', fieldType: 'text', dataType: 'number', required: false, disabled: false, pattern: '/^[a-zA-Z]+$/', maxLength: '50' },
];
function Newuser(props: any) {
  const [generalgroup, setGeneralgroup] = useState<any>([generalFields]);
  const [password, setPassword] = useState(true);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedJournals, setSelectedJournals] = useState([]);
  const [roles, setUserRole] = useState([]);
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [passwordvalue, setPasswordValue] = useState("");
  const [emailStatus, setemailStatus] = useState("");
  const [isLoader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [render, setrender] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [roleoptions, setRoleOptions] = useState([]);
  const [journalOptins, setJournalOptions] = useState([]);
  const [emailStatusArray, setEmailStatusArray] = useState<any>([]);
  const [newFormIndex, setUserIndex] = useState<any>();
  const [emailValue, setEmailValue] = useState("");
  const location = useLocation();
  const userData = location.state && location.state.userData;

  useEffect(() => {
    // clearState();
    getUserRole("role");
    getJournalTitleList("journal");
    getPropsData();
  }, []);

  useEffect(() => {
    if (location.state && location.state.isEdit === false) {
      clearState();
    }
  }, [location]);

  const clearState = async () => {
    setGeneralgroup([generalFields.map((field) => ({ ...field, value: "" }))]);
    setPassword(false);
    setSelectedRoles([]);
    setSelectedJournals([]);
    setUserRole([]);
    setFirstName("");
    setLastName("");
    setEmail("");
    setPasswordValue("");
    setemailStatus("");
    setLoader(false);
    setrender(true);
    setSubmitted(false);
    setRoleOptions([]);
    setJournalOptions([]);
    setEmailStatusArray([]);
    setEmailValue("");
  };

  const getPropsData = async () => {
    // If userData is available, set the form fields
    if (userData) {
      let roleData: any = [];
      // let data: any = typeof userData?.roles === 'object' ? [userData?.roles] : userData?.roles;
      userData?.roles.map((list: any) =>
        roleData.push({ value: list.name, label: list.name, id: list.roleid })
      );

      if (roleData.length > 0) {
        setisEdit(true);
      }
      const updatedForms = generalFields.map((field) => {
        switch (field.fieldName) {
          case "firstname":
            field.value = userData.firstname;
            break;
          case "lastname":
            field.value = userData.lastname;
            break;
          case "email":
            field.value = userData.email;
            break;
          case "role":
            field.value = roleData;
            break;
          // Add other cases for additional fields if needed
          default:
            break;
        }
        return field;
      });
      // Pre-populate values for 'Role'

      // Pre-populate values for 'Assign Journal'
      const journalField = updatedForms.find(
        (field) => field.fieldName === "assignedjournal"
      );
      if (journalField) {
        const selectedJournals =
          userData.roles[0].roleid === 2
            ? userData.editorjournal.map((journal: any) => ({
                label: journal.code,
                value: journal.code,
                id: journal.journalid,
              }))
            : userData.roles[0].roleid === 4
            ? userData.languagejournal.map((journal: any) => ({
                label: journal.code,
                value: journal.code,
                id: journal.journalid,
              })) : userData.reviewerjournal.map((journal: any) => ({
                label: journal.code,
                value: journal.code,
                id: journal.journalid,
              }));

        journalField.value = selectedJournals;
      }
      console.log("updatedForms", updatedForms);

      setGeneralgroup([updatedForms]); // Update this line to set the state with pre-populated values
    }
  };

  const handleFormChange = (
    e: any,
    userIndex: number,
    fieldIndex: number,
    field: string,
    fieldName: string
  ) => {
    const updatedForms = [...generalgroup];
    const updatedForm = { ...updatedForms[userIndex][fieldIndex] };
    updatedForm.value = e.target.value;

    if (updatedForm.required && updatedForm.value.trim() === "") {
      updatedForm.error = `${updatedForm.label} is required.`;
    } else if (fieldName === "firstname" || fieldName === "lastname") {
      if (!/^[a-zA-Z\s]+$/.test(updatedForm.value)) {
        // updatedForm.error = `Invalid ${updatedForm.label}. Please use alphabets only.`;
        e.preventDefault();
        return;
      } else {
        updatedForm.error = "";
      }
    } else if (fieldName === "email") {
      if (
        !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(updatedForm.value)
      ) {
        updatedForm.error = "Enter a correct email format.";
      } else {
        updatedForm.error = "";
      }
    } else {
      updatedForm.error = "";
    }

    updatedForms[userIndex][fieldIndex] = updatedForm;
    setGeneralgroup(updatedForms);
    setSubmitted(false);
  };

  const handleFormSelection = (
    e: any,
    userIndex: number,
    fieldIndex: number,
    field: string
  ) => {
    if (field === "generalFields") {
      if (e.target !== " ") {
        const updatedForms = [...generalgroup];
        updatedForms[userIndex][fieldIndex].value = e.target;
        updatedForms[userIndex][fieldIndex].id = e.id;

        if (
          updatedForms[userIndex][fieldIndex].fieldName === "assignedjournal"
        ) {
          updatedForms[userIndex][fieldIndex].value = e;
        } else if (updatedForms[userIndex][fieldIndex].fieldName === "role") {
          updatedForms[userIndex][fieldIndex].value = e;
        }

        setGeneralgroup(updatedForms);
        setrender(!render);
      }
    }
  };

  const getUserRole = async (type: any) => {
    try {
      let url = apiUrl.nodeApi.getUserRoles;
      // const response = await axios.get(`${config.prapp.basURL}${url}`);
      const response: any = await invokeGetService(url, {}, {}, props.isToken);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      let fileteredRole: any = response.data.data.result.filter(
        (list: any) => list.value != "Author"
      );
      setRoleOptions(fileteredRole);
    } catch (error) {}
  };
  const getJournalTitleList = async (type: any) => {
    try {
      let url = apiUrl.nodeApi.getJournalTitle;
      setLoader(true);
      const response: any = await invokeGetService(url, {}, {}, props.isToken);
      setLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      let data: any = [];
      response.data.data.result.map((list: any) => {
        data.push({
          value: list.code,
          label: list.code,
          id: list.id,
        });
      });
      setJournalOptions(data);
    } catch (error) {
      setLoader(false);
    }
  };

  const togglePassword = () => {
    setPassword(!password);
  };
  const handleBack = () => {
    //clear the userData from the location state
    clearState();
    navigate("/usermanagement", { state: { userData: null } });
  };

  const checkEmailAvailability = async (evalue: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        let url = apiUrl.nodeApi.EmailAvailabilityrolebased;
        debugger;
        const allFormsData = generalgroup.map((forms: any) => {
        return forms.reduce((formData: any, form: any) => {
          formData[form.fieldName] = form.value;
          return formData;
        }, {});
      });
        const combinedData = allFormsData.reduce((result: any, data: any) => {
        return { ...result, ...data };
      }, {});
        const queryParams = { email: evalue , roleid: combinedData.role.id};
        const response: any = await invokeGetService(
          url,
          {},
          queryParams,
          props.isToken
        );
        if (!response.data.data.isSuccess) {
          resolve(false);
        } else {
          resolve(true);
        }
      } catch (error) {
        toastError(`Invalid email format. Please enter a valid email.`);
      }
    });
  };

  const handleMailValidate = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const emailStatusCopy = [...emailStatusArray];
        emailStatusCopy[newFormIndex] = "";

        if (
          !(
            emailValue.length > 0 &&
            /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(emailValue)
          )
        ) {
          emailStatusCopy[newFormIndex] = "Enter a correct email format.";
          setEmailStatusArray(emailStatusCopy);
          resolve(false);
        } else {
          let status = await checkEmailAvailability(emailValue);
          if (status) {
            emailStatusCopy[newFormIndex] = "";
            setEmailStatusArray(emailStatusCopy);
            resolve(true);
          } else {
            emailStatusCopy[newFormIndex] = "Already email registered";
            setEmailStatusArray(emailStatusCopy);
            resolve(false);
          }
        }
      } catch (error) {}
    });
  };

  const handleSave = async () => {
    try {
      const allFormsData = generalgroup.map((forms: any) => {
        return forms.reduce((formData: any, form: any) => {
          formData[form.fieldName] = form.value;
          return formData;
        }, {});
      });
  
      for (const list of allFormsData) {
        if (
          !list.firstname ||
          !list.lastname ||
          !list.email ||
          list.assignedjournal.length === 0
        ) {
          throw new Error(
            "Fill all mandatory fields before adding another user."
          );
        }
        
        // Check if email already exists
        const emailExists = await checkEmailAvailability(list.email);
        if (!emailExists) {
          throw new Error(`Email ${list.email} already exists in the system.`);
        }
      }
  
      const requestData = allFormsData.map((list: any) => {
        const mappedJournal = list.assignedjournal.map(
          (journal: any) => journal.id
        );
        return {
          firstname: list.firstname,
          lastname: list.lastname,
          email: list.email,
          mappedJournal: mappedJournal,
          roleid: list.role.id,
        };
      });
  
      if (requestData.length > 0) {
        const url = apiUrl.nodeApi.MultipleUserRegister;
        setLoader(true);
        const response: any = await invokePostService(
          url,
          requestData,
          props.isToken
        );
        if (!response.data.data.isSuccess) {
          throw new Error(response.data.data.Error);
        }
        toastSuccess("User added successfully");
        navigate("/usermanagement", { state: { userData: null } });
      } else {
        toastError("No user data to save.");
      }
  
      setLoader(false);
    } catch (error: any) {
      setLoader(false);
      toastError(`${error}`);
    }
  };

  const handleedit = async () => {
    try {
      const allFormsData = generalgroup.map((forms: any) => {
        return forms.reduce((formData: any, form: any) => {
          formData[form.fieldName] = form.value;
          return formData;
        }, {});
      });

      // Perform validation
      const isValidationFailed = allFormsData.some((formData: any) => {
        return (
          !formData.firstname ||
          !formData.lastname ||
          !formData.email ||
          formData.assignedjournal.length === 0
        );
      });

      if (isValidationFailed) {
        toastError("Fill all mandatory fields before updating the user.");
        return; // Exit function early if validation fails
      }

      // Continue with the update process
      const combinedData = allFormsData.reduce((result: any, data: any) => {
        return { ...result, ...data };
      }, {});

      let payload = {
        ...combinedData,
        mappedJournal: combinedData.assignedjournal.map((item: any) => item.id),
        roleid: combinedData.role[0].id,
        userid: userData.userid,
      };

      let url = apiUrl.nodeApi.UserProfileUpdate;
      setLoader(true);

      let response: any = await invokePostService(url, payload, props.isToken);
      if (!response.data.data.isSuccess) {
        throw new Error(response.data.data.Error);
      }

      toastSuccess("User Updated successfully");
      navigate("/usermanagement", { state: { userData: null } });
      clearState();
      setLoader(false);
    } catch (error: any) {
      // Show toast message for validation error
      toast.error(`${error.message}`);
      setLoader(false);
    }
  };

  const removeForm = (formIndexToRemove: any) => {
    setGeneralgroup((prevForms: any) => {
      const updatedForms = prevForms.filter(
        (_: any, index: any) => index !== formIndexToRemove
      );
      return updatedForms;
    });
  };

  const addAnotherUser = async () => {
    // if(emailStatusArray[0].length ==0){
    setSubmitted(true);
    setrender(!render);

    let hasEmptyField = false;
    generalgroup.forEach((arr: any, index: any) => {
      const isCurrentArrayValid = arr.every(
        (field: any) => field.required && field.value !== ""
      );

      if (!isCurrentArrayValid) {
        hasEmptyField = true;
      }
    });
    if (!hasEmptyField) {
      let mailStatus = await handleMailValidate();
      if (mailStatus) {
        const newForm = generalFields.map((field: any) => ({
          ...field,
          value: "",
        }));
        setGeneralgroup((prevForms: any) => [...prevForms, newForm]);
        clearState();

        setrender(!render);
      }
    } else {
      toastError("Fill all mandatory fields before adding another user.");
    }
  };

  return (
    <>
      {isLoader && <WHSLoader></WHSLoader>}

      <div className="page-title">
        <div className="d-flex">
          <Button
            onClick={handleBack}
            className="iconBtn"
            title="Back"
            style={{ padding: "0px" }}
          >
            <span className="material-icons">chevron_left</span>
          </Button>
          <h3>{isEdit === true ? 'Edit User' : 'Add New User'}</h3>
        </div>
        {/* <Button className="iconBtn uploadBtn">
                    <span className="material-icons">
                        upload
                    </span>
                    Bulk Upload</Button> */}
      </div>
      <div>
        {generalgroup.map((userForm: any, userIndex: number) => (
          <div
            key={userIndex}
            className={userIndex > 0 ? "row newUseradded" : "row"}
          >
            {Array.isArray(userForm)
              ? userForm.map((form: any, fieldIndex: number) => (
                  <>
                    {form.fieldType === "dropdown" &&
                      form.fieldName === "role" && (
                        <>
                          <div
                            key={fieldIndex}
                            className="col-lg-12 col-md-12 col-sm-12"
                          >
                            <div className="row">
                              <div
                                key={fieldIndex}
                                className="col-lg-4 col-md-12 col-sm-12 form-group"
                              >
                                <label>
                                  {form.label}{" "}
                                  {form.required && (
                                    <span className="text-danger">*</span>
                                  )}{" "}
                                </label>
                                <WMSSelect
                                  className="form-control"
                                  placeHolder={form.placeHolder}
                                  options={roleoptions}
                                  name="fileTypes"
                                  value={form.value}
                                  disabled={isEdit}
                                  isMulti={false}
                                  onChange={(e: any) =>
                                    handleFormSelection(
                                      e,
                                      userIndex,
                                      fieldIndex,
                                      "generalFields"
                                    )
                                  }
                                  id="fileTypes"
                                />
                                {submitted && form.required && !form.value && (
                                  <span className="error">
                                    {form.label} is required
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    {form.fieldType === "dropdown" &&
                      form.fieldName === "assignedjournal" && (
                        <>
                          <div
                            key={fieldIndex}
                            className="col-lg-12 col-md-12 col-sm-12"
                          >
                            <div className="row">
                              <div
                                key={fieldIndex}
                                className="col-lg-4 col-md-12 col-sm-12 form-group"
                              >
                                <label>
                                  {form.label}{" "}
                                  {form.required && (
                                    <span className="text-danger">*</span>
                                  )}{" "}
                                </label>
                                <WMSSelect
                                  className="form-control"
                                  placeHolder={form.placeHolder}
                                  options={journalOptins}
                                  name="fileTypes"
                                  value={form.value}
                                  isMulti={true}
                                  onChange={(e: any) =>
                                    handleFormSelection(
                                      e,
                                      userIndex,
                                      fieldIndex,
                                      "generalFields"
                                    )
                                  }
                                  id="fileTypes"
                                />
                                {submitted && form.required && !form.value && (
                                  <span className="error">
                                    {form.label} is required
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    {form.fieldType === "text" &&
                      (form.fieldName === "firstname" ||
                        form.fieldName === "lastname") && (
                        <>
                          <div
                            key={fieldIndex}
                            className="col-lg-4 col-md-12 col-sm-12 form-group"
                          >
                            <label>
                              {form.label}{" "}
                              {form.required && (
                                <span className="error">*</span>
                              )}
                            </label>
                            <WMSInput
                              type="text"
                              placeHolder={form.placeHolder}
                              className="form-control"
                              value={form.value}
                              disabled={form.disabled}
                              maxLength={form.maxLength}
                              onChange={(e: any) =>
                                handleFormChange(
                                  e,
                                  userIndex,
                                  fieldIndex,
                                  "generalFields",
                                  form.fieldName
                                )
                              }
                              id={form.fieldName}
                            />
                            {submitted && form.required && !form.value && (
                              <span className="error">
                                {form.label} is required
                              </span>
                            )}
                            {form.error && (
                              <span className="error">{form.error}</span>
                            )}
                          </div>
                        </>
                      )}
                    {form.fieldType === "text" &&
                       form.fieldName === "email" && (
                        <>
                          <div
                            key={fieldIndex}
                            className="col-lg-12 col-md-12 col-sm-12"
                          >
                            <div className="row">
                              <div
                                key={fieldIndex}
                                className="col-lg-4 col-md-12 col-sm-12 form-group"
                              >
                                <label>
                                  {form.label}{" "}
                                  {form.required && (
                                    <span className="error">*</span>
                                  )}
                                </label>
                                <WMSInput
                                  type="text"
                                  placeHolder={form.placeHolder}
                                  className="form-control"
                                  value={form.value}
                                  disabled={isEdit} // Change this line to disable when in edit mode
                                  maxLength={form.maxLength}
                                  onChange={(e: any) =>
                                    handleFormChange(
                                      e,
                                      userIndex,
                                      fieldIndex,
                                      "generalFields",
                                      form.fieldName
                                    )
                                  }
                                  id={form.fieldName}
                                />
                                {submitted && form.required && !form.value && (
                                  <span className="error">
                                    {form.label} is required
                                  </span>
                                )}
                                {form.fieldName === "email" &&
                                  emailStatusArray[userIndex] && (
                                    <span className="error">
                                      {emailStatusArray[userIndex]}
                                    </span>
                                  )}
                                {form.error && (
                                  <span className="error">{form.error}</span>
                                )}
                              </div>
                            </div>
                          </div>
                          {userIndex > 0 && (
                            <Button
                              onClick={() => removeForm(userIndex)}
                              className="iconBtn"
                            >
                              <span className="material-icons">delete</span>
                            </Button>
                          )}
                        </>
                      )}
                  </>
                ))
              : null}
          </div>
        ))}
      </div>

      {
        userData ? "" : <></>
        // <div className="add_user">
        //     <Button onClick={addAnotherUser}>
        //         <span className="material-icons">
        //             add
        //         </span>
        //         Add Another User
        //     </Button>

        // </div>
      }
      <div className="mb-5">
        {userData ? (
          <Button onClick={handleedit} className="mr-3">
            UPDATE
          </Button>
        ) : (
          <Button onClick={handleSave} className="mr-3">
            SAVE
          </Button>
        )}
        <Button onClick={handleBack} variant="outline-secondary">
          CANCEL
        </Button>
      </div>
    </>
  );
}
const mapStateToProps = (state: any) => {
  return {
    isLogged: state.rootReducer.authReducer.isLoggedIn,
    isToken: state.rootReducer.authReducer.token,
    userInfo: state.rootReducer.authReducer.userInfo,
  };
};

export default connect(mapStateToProps, null)(HOCAutoLogout(Newuser));
